import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Button,
} from "@mui/material";

const ResetListDialog = ({
  open,
  onClose,
  onSave,
  selectedOption,
  comment,
  setSelectedOption,
  setComment,
  title = "Resetuj listę - wybierz powód resetu:",
  showRadioGroup = true,
}) => {
  const handleSaveClick = () => {
    onSave();
  };

  const shouldShowComment =
    !showRadioGroup || selectedOption === "1" || selectedOption === "2";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {showRadioGroup && (
          <RadioGroup
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
          >
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="Błędnie przygotowana odprawa"
            />
            <FormControlLabel value="2" control={<Radio />} label="Inne" />
          </RadioGroup>
        )}

        {shouldShowComment && (
          <TextField
            label="Komentarz"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            fullWidth
            multiline
            margin="normal"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Anuluj</Button>
        <Button
          onClick={handleSaveClick}
          variant="contained"
          disabled={
            showRadioGroup
              ? !selectedOption || (shouldShowComment && !comment.trim())
              : !comment.trim()
          }
        >
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetListDialog;
